function createLocalCourse(user, input) {
  const internalId = `${input.title}-${input.levels.join(",")}-${input.subjects.join(",")}`;
  return {
    ownerId: user?.id ?? "",
    id: internalId,
    __internalId: internalId,
    createdAt: new Date(),
    modifiedAt: new Date(),
    blocks: [],
    ...input
  };
}

export { createLocalCourse };
//# sourceMappingURL=create-local-course.js.map
